import { Redirect } from 'react-router-dom'

// This is a legacy redirect
export const AddChildPage = () => <Redirect to="/connect" />
